import React from "react";

export function MetricCard({ overline, value, unit, hint, icon: Icon, accent = "primary", testId }) {
  const accentClasses =
    accent === "accent"
      ? "text-accent"
      : accent === "muted"
      ? "text-muted-foreground"
      : "text-primary";

  return (
    <div
      data-testid={testId}
      className="border border-border rounded-lg bg-card p-6 flex flex-col h-full"
    >
      <div className="flex items-start justify-between">
        <div className="overline text-muted-foreground">{overline}</div>
        {Icon && <Icon className={`w-5 h-5 ${accentClasses}`} />}
      </div>
      <div className="mt-4 flex items-baseline gap-2">
        <span className="font-display text-4xl font-bold tracking-tight">{value}</span>
        {unit && <span className="text-sm text-muted-foreground">{unit}</span>}
      </div>
      {hint && <div className="mt-3 text-xs text-muted-foreground">{hint}</div>}
    </div>
  );
}
